import { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import SalesProfit from '../../components/dashboard/SalesProfit'
import MakePieChart from '../../components/dashboard/MakePieChart'
import UnitCountFour from "../../components/dashboard/UnitCountFour";
import RevenueStatisticsOne from "../../components/dashboard/RevenueStatisticsOne";
import SalesStatisticTwo from "../../components/dashboard/SalesStatisticTwo";
import TopCountriesTwo from "../../components/dashboard/TopCountriesTwo";
import UserActivatesTwo from "../../components/dashboard/UserActivatesTwo";
import LatestInvestmentsOne from "../../components/dashboard/LatestInvestmentsOne";
import NoticeBoardOne from "../../components/dashboard/NoticeBoardOne";
import TotalTransactionsOne from "../../components/dashboard/TotalTransactionsOne";
import ProjectStatusOne from "../../components/dashboard/ProjectStatusOne";
import { api } from "../../utils/apiClient";
import ContentLoader from '../../utils/ContentLoader';
import Flatpickr from "react-flatpickr";
import { Popover } from "antd";
import { Icon } from '@iconify/react/dist/iconify.js';
import { formatDateToYMD } from "../../utils/tools";
import UsersGraph from "../../components/dashboard/usersGraph";
import ReadersGraph from "../../components/dashboard/readersGraph";
import SubscribersGraph from "../../components/dashboard/subscribersGraph";


const DashboardPage = () => {
  const [dashboard, setDashboard] = useState(null);
  const [trends, setTrends] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔥 all widget filters here
  // const [filters, setFilters] = useState({
  //   make: "Monthly",
  //   insurance: "Monthly",
  //   sales: "Monthly"
  // });
  const [quickDateOpen, setQuickDateOpen] = useState(false);


  const getDefaultCurrentMonthRange = () => {
    const end = new Date();
    end.setHours(0, 0, 0, 0); // remove time

    const start = new Date(end.getFullYear(), end.getMonth(), 1);
    start.setHours(0, 0, 0, 0);

    return [start, end];
  };

  const [dateRange, setDateRange] = useState(getDefaultCurrentMonthRange());

  // //----------------- DASBOARD API ------------------------
  const fetchDashboardCounts = async () => {
    try {
      setLoading(true);
      const { startDate, endDate } = getFormattedDates();
      const res = await api.get("/dashboard", {
        params: {
          startDate,
          endDate,
        },
      });

      console.log("dashboard API response:", res.data.data);

      setDashboard(res.data.data);
      setTrends(res.data.trends);
    } catch (error) {
      console.error("Dashboard API error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardCounts();
  }, [dateRange]);

  // ------------DATE FORMAT--------------
  const getFormattedDates = () => {
    if (!dateRange || dateRange.length === 0) return {};

    const start = dateRange[0];
    const end = dateRange.length === 2 && dateRange[1] ? dateRange[1] : null;

    return {
      startDate: formatDateToYMD(start),
      endDate: end ? formatDateToYMD(end) : null, // null if not selected
    };
  };


  //--------------- POPOVER DATE SELECTION --------------
  const getQuickRanges = () => {
    const now = new Date();

    const startOfMonth = (year, month) =>
      new Date(year, month, 1, 0, 0, 0, 0);

    const endOfMonth = (year, month) =>
      new Date(year, month + 1, 0, 23, 59, 59, 999);

    const startOfYear = (year) =>
      new Date(year, 0, 1, 0, 0, 0, 0);

    const endOfYear = (year) =>
      new Date(year, 11, 31, 23, 59, 59, 999);

    // previous month reference
    const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    return [
      {
        label: "Today",
        range: [
          new Date(now.setHours(0, 0, 0, 0)),
          new Date(),
        ],
      },

      {
        label: "Last Week",
        range: [
          (() => {
            const d = new Date();
            d.setDate(d.getDate() - 7); // 7 days ago
            d.setHours(0, 0, 0, 0);     // start of that day
            return d;
          })(),
          (() => {
            const d = new Date();
            d.setHours(0, 0, 0, 0);     // today at 00:00
            return d;
          })(),
        ],
      },
      {
        label: "Last Month",
        range: [
          startOfMonth(prevMonth.getFullYear(), prevMonth.getMonth()),
          endOfMonth(prevMonth.getFullYear(), prevMonth.getMonth()),
        ],
      },

      {
        label: "Last 3 Months",
        range: [
          startOfMonth(prevMonth.getFullYear(), prevMonth.getMonth() - 2),
          endOfMonth(prevMonth.getFullYear(), prevMonth.getMonth()),
        ],
      },

      {
        label: "Last 6 Months",
        range: [
          startOfMonth(prevMonth.getFullYear(), prevMonth.getMonth() - 5),
          endOfMonth(prevMonth.getFullYear(), prevMonth.getMonth()),
        ],
      },

      {
        label: "Last Year",
        range: [
          startOfYear(now.getFullYear() - 1),
          endOfYear(now.getFullYear() - 1),
        ],
      },
    ];
  };


  //console.log("dashboard========>", dashboard);

  if (loading) return <ContentLoader />;
  // console.log("dashboard====>", dashboard)
  // console.log("USER DATA:", dashboard?.user_data);
  // console.log("GRAPH COUNTS:", dashboard?.graph_counts);
  return (
    <>

      <div className="d-flex align-items-center justify-content-between mb-20 dashboard-header">
        {/* Left */}
        <Breadcrumb title="Dashboard" />

        {/* Right */}
        <div className="d-flex align-items-center gap-2 header-right">
          <Flatpickr
            options={{ mode: "range", dateFormat: "d/m/Y", maxDate: "today" }}
            value={dateRange}
            onChange={(dates) => {
              if (dates.length === 2) {
                setDateRange(dates);
              }
            }}
            className="gf-input form-control form-control-sm"
            style={{ maxWidth: 240 }}
            placeholder="Start date - End date"
          />

          <Popover
            trigger="click"
            placement="bottomRight"
            open={quickDateOpen}
            onOpenChange={setQuickDateOpen}
            overlayClassName="action-popover"
            content={
              <div className="action-list">
                {getQuickRanges().map((item) => (
                  <button
                    key={item.label}
                    className="action-item"
                    onClick={() => {
                      setDateRange(item.range);   // ✅ set date
                      setQuickDateOpen(false);    // ✅ close popover
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            }
          >
            <button
              type="button"
              className="w-32-px h-32-px bg-neutral-300 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
            >
              <Icon icon="mdi:dots-vertical" />
            </button>
          </Popover>

        </div>
      </div>



      <section className="row gy-4">

        {/* UnitCountFour */}
        <UnitCountFour
          todayEvents={dashboard?.counts?.todayEvents}
          newEvents={dashboard?.counts?.newEvents}
          acceptedEvents={dashboard?.counts?.acceptedEvents}
          todayUsers={dashboard?.counts?.todayUsers}
          totalUsers={dashboard?.counts?.totalUsers}
          todayReaders={dashboard?.counts?.todayReaders}
          totalReaders={dashboard?.counts?.totalReaders}
          totalChurches={dashboard?.counts?.totalChurches}
        />

        <SubscribersGraph
          graphData={dashboard?.subscriber_data}
        />
        <UsersGraph
          graphData={dashboard?.user_data}
        />
        <SalesProfit
          graphData={dashboard?.graph_counts}
        />

       

        <ReadersGraph
          graphData={dashboard?.readers_data}
          newUsers={dashboard?.readers_data?.todayReaders}
        />
      </section>


    </>
  );
};

export default DashboardPage;






